module.exports = __webpack_public_path__ + "static/wash_card_img2@2x-52fa30bee937eae4fc6072e503bfe0e1.jpg";